(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rennoa-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-rn-header]');
    if (!header || header.dataset.rnInit) return;
    header.dataset.rnInit = '1';
    var scrim = header.querySelector('[data-rn-scrim]');

    function scrimBelowHeader() {
      if (!scrim) return;
      scrim.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
    }

    /* ---------- desktop megamenu (hover intent) ---------- */
    header.querySelectorAll('[data-rn-mega-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-rn-mega]');
      var panel = document.getElementById(item.getAttribute('data-rn-target'));
      if (!panel) return;
      var inner = panel.querySelector('.rn-mega__inner');
      var closeTimer = null, open = false;

      function doOpen() {
        clearTimeout(closeTimer);
        if (open) return;
        open = true;
        panel.querySelectorAll('.rn-prod, .rn-tab').forEach(function (el, i) { el.style.transitionDelay = (110 + i * 40) + 'ms'; });
        panel.style.height = inner.offsetHeight + 'px';
        panel.classList.add('is-open');
        item.classList.add('is-open');
        scrimBelowHeader();
        scrim.classList.add('is-visible');
        trigger.setAttribute('aria-expanded', 'true');
      }
      function doClose() {
        if (!open) return;
        open = false;
        panel.querySelectorAll('.rn-prod, .rn-tab').forEach(function (el) { el.style.transitionDelay = '0ms'; });
        panel.style.height = '0px';
        panel.classList.remove('is-open');
        item.classList.remove('is-open');
        scrim.classList.remove('is-visible');
        trigger.setAttribute('aria-expanded', 'false');
      }
      function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(doClose, 170); }

      item.addEventListener('mouseenter', doOpen);
      item.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
      trigger.addEventListener('click', function (e) { e.preventDefault(); open ? doClose() : doOpen(); });
      window.addEventListener('resize', function () { if (open) { panel.style.height = inner.offsetHeight + 'px'; scrimBelowHeader(); } });
      item._rnClose = doClose;
    });

    /* ---------- mobile drawer + submenus ---------- */
    function closeAllMega() { header.querySelectorAll('[data-rn-mega-item]').forEach(function (it) { if (it._rnClose) it._rnClose(); }); }
    function openDrawer() { if (scrim) scrim.style.top = '0px'; header.classList.add('is-drawer-open'); scrim.classList.add('is-visible'); document.documentElement.style.overflow = 'hidden'; }
    function closeDrawer() { header.classList.remove('is-drawer-open'); scrim.classList.remove('is-visible'); document.documentElement.style.overflow = ''; header.querySelectorAll('.rn-submenu.is-open').forEach(function (p) { p.classList.remove('is-open'); }); }

    header.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-rn-open]');
      var closeBtn = e.target.closest('[data-rn-close]');
      var sub = e.target.closest('[data-rn-sub]');
      var back = e.target.closest('[data-rn-back]');
      if (openBtn) { e.preventDefault(); openDrawer(); return; }
      if (closeBtn) { e.preventDefault(); closeDrawer(); return; }
      if (sub) { e.preventDefault(); var p = document.getElementById(sub.getAttribute('data-rn-sub')); if (p) p.classList.add('is-open'); return; }
      if (back) { e.preventDefault(); var pnl = back.closest('.rn-submenu'); if (pnl) pnl.classList.remove('is-open'); return; }
    });

    if (scrim) scrim.addEventListener('click', function () { closeDrawer(); closeAllMega(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeAllMega(); } });

    /* native selector auto-submit */
    header.querySelectorAll('.rn-loc__select').forEach(function (sel) { sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); }); });

    /* ------------------------------------------------------------------
       Market selector relocator (Orbe Geolocation & friends)

       The app mounts ONE instance into .rn-tlab-desktop. Below the
       breakpoint we MOVE that live node into the drawer slot (and back
       up again on resize). Moving — not cloning — keeps the app's own
       event listeners intact.
    ------------------------------------------------------------------ */
    (function () {
      var deskSlot = header.querySelector('[data-rn-locslot="desktop"]');
      var mobSlot  = header.querySelector('[data-rn-locslot="mobile"]');
      var drawerTop = header.querySelector('[data-rn-drawer-top]');
      if (!deskSlot || !mobSlot) return;

      var bp = parseInt(header.getAttribute('data-rn-loc-breakpoint'), 10) || 989;
      var mq = window.matchMedia('(max-width: ' + bp + 'px)');
      var busy = false;

      function markDrawer() {
        if (!drawerTop) return;
        var filled = mobSlot.children.length > 0 || !!drawerTop.querySelector('.rn-market select');
        drawerTop.classList.toggle('has-loc', filled);
      }

      function place() {
        if (busy) return;
        busy = true;

        var target = mq.matches ? mobSlot : deskSlot;
        var source = mq.matches ? deskSlot : mobSlot;

        // 1) adopt anything the app injected as a SIBLING instead of a child
        var host = deskSlot.parentElement;
        if (host) {
          host.querySelectorAll(':scope > [class*="orbe" i], :scope > [id*="orbe" i], :scope > [class*="switcher" i]').forEach(function (n) {
            if (n !== deskSlot && n !== mobSlot) deskSlot.appendChild(n);
          });
        }

        // 2) move everything into the slot that matches the current viewport
        while (source.firstChild) target.appendChild(source.firstChild);

        markDrawer();
        // let the DOM settle before the observer is allowed to react again
        requestAnimationFrame(function () { busy = false; });
      }

      // the app injects asynchronously — watch until it shows up, and keep
      // watching in case it re-renders (e.g. after a market change)
      new MutationObserver(place).observe(header, { childList: true, subtree: true });

      if (mq.addEventListener) { mq.addEventListener('change', place); }
      else if (mq.addListener) { mq.addListener(place); }

      place();
      window.addEventListener('load', place);
      document.addEventListener('shopify:section:load', place);
    })();
  })();

  } catch(e) { console.error(e); }
})();
})();
